import { render, staticRenderFns } from "./PunchRules.vue?vue&type=template&id=916ccb96&scoped=true&"
import script from "./PunchRules.vue?vue&type=script&lang=js&"
export * from "./PunchRules.vue?vue&type=script&lang=js&"
import style0 from "./PunchRules.vue?vue&type=style&index=0&id=916ccb96&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "916ccb96",
  null
  
)

export default component.exports